import Button from 'components/Button'
import UploadResultIcon from 'components/icons/UploadResultIcon'
import {
  ButtonDiv,
  FileInfoDiv,
  ResultDiv,
  ResultIconDiv,
  UploadMsgFlex,
} from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/ReleaseOfferDrawer/Components/ConfirmReleaseOffer/style'
import React from 'react'

const ConfirmReleaseOffer = ({
  setReviewOffer,
  setConfirmOffer,
  selectedCandidate,
}) => {
  const handleClose = () => {
    setReviewOffer(false)
    setConfirmOffer(false)
  }
  return (
    <UploadMsgFlex column center centerVertically>
      <ResultIconDiv>
        <UploadResultIcon />
      </ResultIconDiv>
      <ResultDiv>Offer Notification Sent Successfully</ResultDiv>

      <FileInfoDiv>
        Offer notification sent to{' '}
        {selectedCandidate?.length > 1 ? selectedCandidate?.length : ''}{' '}
        candidat successfully.
      </FileInfoDiv>

      <ButtonDiv>
        {' '}
        <Button.Secondary
          text="Close"
          width="80px"
          height="36px"
          onClick={handleClose}
        />
      </ButtonDiv>
    </UploadMsgFlex>
  )
}

export default ConfirmReleaseOffer
